// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8dff5278","239":"301a3114","453":"4786dc18","667":"c193bbe2"}[chunkId] + ".chunk.js";
};